<template>
  <BaseLayout pageTitle="我的">
    <div class="my">
      <div class="header m-b-20">
        <img
          v-if="store.getters['user/info'].imgUrl"
          :src="store.getters['user/info'].imgUrl"
          class="avatarImage m-r-20"
        />
        <div
          v-else
          class="defaultAvatarImage primary-bg m-r-20"
        >{{store.getters['user/info'].userName?.substr(0,1)}}</div>
        <div class="f-column p-t-20">
          <div class="f-y-center">
            <img class="lsCheckImage m-r-25" src="@/assets/ls_check_1.png" />
            <div class="title">{{store.getters['user/info'].userName}}</div>
          </div>
          <img class="certificationImage m-t-15 m-b-15" src="@/assets/certification.png" />
          <!-- <div class="darkgray-font">账号：yonghu@email.com</div> -->
        </div>
      </div>
      <ItemNav label="编辑资料">
        <template v-slot:image></template>
      </ItemNav>
      <ItemNav label="我的上传">
        <template v-slot:image></template>
      </ItemNav>
      <ItemNav class="m-b-25" label="修改密码">
        <template v-slot:image></template>
      </ItemNav>
      <ItemNav label="联系客服">
        <template v-slot:image></template>
      </ItemNav>
      <ItemNav label="检查更新">
        <template v-slot:image></template>
      </ItemNav>
      <ItemNav label="用户协议&隐私协议">
        <template v-slot:image></template>
      </ItemNav>

      <ion-button expand="block" color="primary" class="logout" @click="logout">退出登录</ion-button>
    </div>
    <!-- <NativeTabNavigatoLayout /> -->
  </BaseLayout>
</template>

<script>
import { useStore } from 'vuex'
import router from '@/router'
export default {
  setup(props, { emit }) {
    const store = new useStore()
    const logout = async () => {
      // await store.dispatch('user/logout')
      router.replace('/login')
    }

    // info

    return { logout, store }
  },
  components: {},
}
</script>


<style lang="scss">
.my {
  background: #f1f2f5;
  height: 100%;
  .defaultAvatarImage {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 178px;
    height: 178px;
    border-radius: 50%;
    font-size: 56px;
    color: #fff;
    background-color: #e6a23c;
  }
  .header {
    display: flex;
    height: 222px;
    background-color: #fff;
    padding-left: 35px;
    padding-top: 20px;
    .avatarImage {
      width: 178px;
      height: 178px;
      border-radius: 50%;
    }
    .lsCheckImage {
      width: 42px;
      height: 42px;
    }
    .certificationImage {
      width: 126px;
      height: 42px;
    }
    .title {
      font-size: 36px;
    }
  }
  .logout {
    height: 80px;
    margin-top: 70px;
    margin-left: 70px;
    margin-right: 70px;
  }
}
</style>